import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const RandomProjects = () => {
const [selectedItems, setSelectedItems] = useState([]);

useEffect(() => {
    const fetchData = async () => {
    try {
        const response = await fetch('/data/progetti.json');
        const data = await response.json();
        const shuffledData = [...data.items].filter((item) => item.published === true).sort(() => 0.5 - Math.random());
        const selected = shuffledData.slice(0, 3);
        setSelectedItems(selected);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    };

    fetchData();
}, []);

return (
    <div className='animated-item fade-in-slide-up delay-2'>
        <ul>
            {selectedItems.map((item) => (
                <li key={item.id} className='p-tb-3 p-r m-b-1'>
                    <Link to={`/details/progetti/${item.id}`}>
                        <ul className='c-50 random-preview-image-container sm-c-100'>
                            <div className='random-preview-image sm-d-b' style={{backgroundImage: `url("/images/progetti/${item.id}/preview.jpg")`}}></div>
                            <ul className='p-r'>
                                <li className='c-15 d-i-b v-a-m sm-c-100 sm-m-t-1'>
                                    <h6 className='sans-serif uppercase c-secondary'>{item.year}</h6>
                                </li>
                                <li className='c-85 d-i-b v-a-m sm-c-100'>
                                    <h3 className='madegra c-light'>{item.title}</h3>
                                </li>
                            </ul>
                        </ul>
                    </Link>
                </li>
            ))}
        </ul>
        <div className='m-t-5 d-b m-c t-a-c'>
            <h6>
                <a href="/progetti" className='d-i-b b-primary c-light button sans-serif uppercase'>Esplora tutti i miei progetti</a>
            </h6>
        </div>
    </div>
);
};

export default RandomProjects;
